var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.a9dc26a008fe1538450500f75ada6a0e.svg#h';
                    var viewUrl = 'sprites.a9dc26a008fe1538450500f75ada6a0e.svg#view-h';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 7 12',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };